// Loader typé pour data/characters.json (dérivé de docs/school/02-personnel.md).
// Le moteur consomme CHARACTERS ; on n'écrit jamais un PNJ en dur dans une scène.
import charactersJson from './characters.json'

export type CharacterCategory =
    | 'direction'
    | 'vie-scolaire'
    | 'sante-social'
    | 'administration'
    | 'restauration'
    | 'enseignant'
    | 'eleve'

export interface CharacterData {
    id: string
    displayName: string
    role: string
    category: CharacterCategory
    /** id de lieu (cf. data/locations.json) où le PNJ se trouve par défaut */
    homeLocation: string
    /** graine DiceBear : même seed => même visage */
    avatarSeed: string
    /** style DiceBear en kebab-case (ex: "big-smile") — cf. avatars/dicebear.ts */
    avatarStyle: string
    traits: string[]
    dialogueHook: string
    /** true => personne réelle nommée : accord requis avant diffusion publique (RGPD) */
    consentRequired: boolean
    source: string
}

// Le JSON contient une clé "_meta" (doc) + "characters". On ne type que "characters".
export const CHARACTERS: CharacterData[] =
    (charactersJson as unknown as { characters: CharacterData[] }).characters

/** Retourne un personnage par son id, ou undefined. */
export function getCharacterById(id: string): CharacterData | undefined {
    return CHARACTERS.find(c => c.id === id)
}

/** Tous les personnages dont le lieu par défaut est `locationId`. */
export function getCharactersByLocation(locationId: string): CharacterData[] {
    return CHARACTERS.filter(c => c.homeLocation === locationId)
}

/** Tous les personnages d'une catégorie (direction, vie-scolaire, …). */
export function getCharactersByCategory(category: CharacterCategory): CharacterData[] {
    return CHARACTERS.filter(c => c.category === category)
}
